<template>
    <div class="custom-select-range-type-1">
        <CustomSelect
            :modelValue="modelValue?.custom || 'all'"
            :inputKey="inputKey"
            @update:modelValue="onSelectChanged"
            :options="optionsRange"
            :showLabel="false"
            :showDescription="false"
        />

        <div v-if="modelValue?.custom === 'custom'" class="form-type-0">
            <CustomRangeSimple
                :inputKey="inputKey"
                :modelValue="rangeValue"
                :min="minBound"
                :max="maxBound"
                :showLabel="false"
                :showLabelMinMax="true"
                :showDescription="false"
                @update:modelValue="onRangeChanged"
            />
        </div>
    </div>
</template>

<script>
    import CustomSelect from '@/components/elements/inputs/CustomSelect';
    import CustomRangeSimple from '@/components/elements/inputs/CustomRangeSimple';

    export default {
        name: "CustomSelectRange",
        components: {
            CustomSelect,
            CustomRangeSimple
        },
        props: {
            modelValue: {
                type: Object,
                default: () => ({ min: null, max: null, custom: 'all' })
            },
            inputKey: {
                type: String,
                default: 'default.range'
            },
            includeAllOption: {
                type: Boolean,
                default: false
            },
            optionsType: {
                type: String,
                default: 'default'
            },
            minBound: {
                type: Number,
                default: 0
            },
            maxBound: {
                type: Number,
                default: 1000
            }
        },
        data() {
            return {
                optionsRange: [
                    ...(this.includeAllOption ? [{ value: 'all', text: 'fields.default.range.all' }] : []),
                    ...(this.optionsType === 'visits' ? [
                        { value: '1', text: 'fields.prospects_filter_visits.option_1' },
                        { value: '0:0', text: 'fields.prospects_filter_visits.option_0' }
                    ] : []),
                    { value: 'custom', text: 'fields.default.range.custom' }
                ]
            }
        },
        computed: {
            rangeValue() {
                return {
                    min: this.modelValue?.min ?? this.minBound,
                    max: this.modelValue?.max ?? this.maxBound
                };
            }
        },
        methods: {
            onSelectChanged(newValue) {
                const updated = { ...this.modelValue, custom: newValue };
                if (newValue !== 'custom') {
                    updated.min = null;
                    updated.max = null;
                }
                this.$emit('update:modelValue', updated);
            },
            onRangeChanged(value) {
                const updated = { ...this.modelValue };
                updated.min = value.min === this.minBound ? null : value.min;
                updated.max = value.max === this.maxBound ? null : value.max;
                this.$emit('update:modelValue', updated);
            }
        }
    }
</script>